<div class="flex flex-col justify-center items-center gap-4 px-6">
  <img
    appImg
    src="assets/gif/download-animate.svg"
    class="w-[190px]"
    alt="download image" />

  <p class="text-white font-bold text-center text-xl mb-2">
    {{ 'common.major-update-available-label' | translate }}
  </p>

  <p class="text-white text-center text-sm mb-4">
    {{ 'common.major-update-desc' | translate }}
  </p>

  <p
    class="text-white text-center text-sm mb-4"
    [innerHTML]="'common.old-version-desc' | translate"></p>

  <div class="w-full">
    <button
      (click)="redirectToPlayStore()"
      class="w-full px-11 text-lg text-center tracking-wider h-14 flex justify-center items-center bg-kimbo-gradient rounded-full font-semibold text-white cursor-pointer shadow-lg">
      {{ 'common.goto-new-version' | translate }}
    </button>
  </div>
</div>
